import { svg } from "lit";
const icon = svg `<path d="M18.2253 22.8982L26.7915 14.3673L25.2915 12.8844L18.2196 19.9678L14.6836 16.4261L13.1922 17.9004L18.2253 22.8982ZM2.30762 33.7176V31.6236H37.6921V33.7176H2.30762ZM4.16653 29.551V6.21777H35.8331V29.551H4.16653ZM6.26049 27.457H33.7392V8.31173H6.26053L6.26049 27.457Z" fill="currentColor"/>`;
export default icon;
